import React from 'react';
import { Text } from '@chakra-ui/react';

/**
 * SubheaderComponent dynamically renders subheaders with configurable styles.
 * @param {string} content - The text content of the subheader.
 * @param {string} variant - The typography variant (e.g., "s1", "s2").
 * @param {string} ariaLabel - Accessibility label for the subheader.
 * @param {string} role - Accessibility role for the subheader.
 * @param {string} color - Optional custom color to override variant or default color.
 */
const SubheaderComponent = ({
  content,
  marginBottom,
  variant = 'body-md-min-reg',
  ariaLabel,
  role = 'heading',
  color,
}) => {
  return (
    <Text
      as={role === 'heading' ? 'h2' : 'p'}
      role={role}
      aria-label={ariaLabel}
      mt={2}
      mb={marginBottom || 0}
      fontFamily={`var(--${variant}-font-family, sans-serif)`}
      fontSize={`var(--${variant}-font-size, 16px)`}
      fontWeight={`var(--${variant}-font-weight, bold)`}
      lineHeight={`var(--${variant}-line-height, 1.5)`}
      letterSpacing={`var(--${variant}-letter-spacing, normal)`}
      textAlign={`var(--${variant}-text-align, left)`}
      color={color || `var(--${variant}-color, var(--sutter-sync-purple))`}
    >
      {content}
    </Text>
  );
};

export default SubheaderComponent;
